/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'
import { css } from '@emotion/core'
import { mediaQueries, getConfig } from '../../twd'

import React from 'react'
import { Disclosures, Loading, show } from '../../twd'
import StatesMap from './states-map'
import Table from './table'
import useMap from './use-map'
import ActiveState from './active-state'

export default () => {

    let { values, error, status } = useMap()
    const isBlue = getConfig('entitlements.ETradeBlue', 'No') === 'Yes'

    return <React.Fragment>
    <div id='municipal-map' className="vertical-offset-sm"></div>
    <div data-name="municipals-map" className="container vertical-offset-sm" css={sectionCss}>

        <div className="row vertical-offset-sm"></div>

        <Loading status={status} error={error}>

        <div className="row">
        <div className="col-md-8 col-xs-12">
            <h3 className="medium-header">Municipal Map</h3>
        </div>
        <div className="col-md-4 col-xs-12 text-small">
            <ActiveState
            />
            <div className="row vertical-offset-sm"></div>
        </div></div>

        <div className="row">
        <div className="col-md-12 table-responsive" css={mapCss}>
        <figure>
        <div aria-hidden="true"><StatesMap values={values} /></div>
        <figcaption className="screen-reader-only">
            <Table values={values} />
        </figcaption>
        </figure>

        </div></div>

        <div className="row" aria-hidden="true">
            <div className="col-md-8 col-xs-12">
            Trades by state:<br/>
            <Legend color={isBlue ? "#00172b" : "#5627D8"} label="1001+" />
            <Legend color={isBlue ? "#002b51" : "#6C43DD"} label="501-1000" />
            <Legend color={isBlue ? "#094274" : "#825FE2"} label="251-500" />
            <Legend color={isBlue ? "#1b5b93" : "#977AE7"} label="101-250" />
            <Legend color={isBlue ? "#467eb0" : "#AD96EC"} label="51-100" />
            <Legend color={isBlue ? "#6496c2" : "#C3B2F1"} label="0-50" />

            </div>
            <div className="col-md-4 col-xs-12 text-right">
                &nbsp;<br/>
                <button
                    data-name="municipals-map-us-territories-link"
                    className="btn btn-link text-small text-bold"
                    onClick={() => {
                    show('offerings', {
                        searchParams: {
                            holdInvType:['M'],
                            holdState: ['AS','GU','VI'],
                            persistToPreviousSearches: false,
                            offeringType: ['ask-side'],
                        },
                        _ts: Date.now(),
                        from:'municipals'
                    })
                }}>
                View offerings from US Territories
                </button>
            </div>
        </div>
        <div className="row">
            <div className="col-md-10 col-xs-12 text-small" aria-hidden="true">
            Municipal map color scale is based upon the number of MSRB-reported trades (by state) from the previous trading day.
            </div>
            <div className="col-md-2 col-xs-12 text-right">
                <Disclosures
                    dataName="municipals-map-disclosures-link"
                    html={DISCLOSURES}
                /></div>
        </div>

        </Loading>

        <div className="row vertical-offset-sm"></div>
    </div>
    </React.Fragment>
}

const Legend = ({color, label}) => {
    return <React.Fragment>
    <div style={{padding:'9px 0', lineHeight:'13px', paddingRight:'10px', minHeight:'33px', display:'inline-block', whiteSpace:'nowrap'}}>
        <svg height="10" width="10">
        <circle cx="5" cy="5" r="5" stroke={color} strokeWidth="1" fill={color} />
        </svg>
        &nbsp;
        {label}
    </div>
    </React.Fragment>
}

const mapCss = css`
${mediaQueries.lg} {
    overflow-x: hidden;
}
`

const DISCLOSURES = `
    The Municipal Map allows you to search for unique CUSIPs being offered
    in each of the 50 states in the US, as well as in US territories.
    The state color scale of the Municipal Map is based upon
    the number of MSRB-reported trades (by state) from the previous trading day.
    The legend at the bottom of the map shows how these trade volumes align with the state color scale.
    You can click on a state to view a list of active municipal bond offerings from that state.
    You can also hover over a state to see current data points for that state’s offerings,
    including: number of unique CUSIPs, general obligation and revenue offerings, and average yields.
`